// support fromEntries syntax below chrome 72
if (!Object.fromEntries) {
    Object.fromEntries = function (iterable: any) {
        return [...iterable].reduce((obj, [key, value]) => {
            obj[key] = value
            return obj
        }, {})
    }
}
